/**
 * Marks card media as loaded so the CSS skeleton in `image-skeleton-styles` can be removed.
 *
 * There is no CSS pseudo-class for a decoded image. Without this, the skeleton keeps
 * animating underneath every loaded image, and stays visible wherever the image does not
 * cover its whole box — letterboxed `contain` media, and images that never arrive.
 */

const SELECTOR = [
  'img.product-media__image',
  'img.resource-image__image',
  'img.resource-card__image',
  'img.resource-card__collection-image',
  'img.blog-post-card__image',
  'img.blog-post-featured-image__image',
  'img.news-card__image',
  'img.gallery-card__image',
  'img.gallery-photos__thumbnail',
  'img.hero-slide__image',
  'img.hero-card__background-image',
].join(',');

/** @param {HTMLImageElement} image */
function markWhenLoaded(image) {
  if (image.dataset.loaded != null) return;

  // `complete` covers cached and bfcache-restored images, which never fire `load`.
  if (image.complete) {
    image.dataset.loaded = '';
    return;
  }

  const done = () => {
    image.dataset.loaded = '';
  };

  image.addEventListener('load', done, { once: true });
  image.addEventListener('error', done, { once: true });
}

/** @param {ParentNode} root */
function scan(root) {
  for (const image of root.querySelectorAll(SELECTOR)) {
    if (image instanceof HTMLImageElement) markWhenLoaded(image);
  }
}

scan(document);

// Filtering, pagination, quick add, cart and predictive search all swap in fresh markup.
new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;

      if (node instanceof HTMLImageElement) {
        if (node.matches(SELECTOR)) markWhenLoaded(node);
      } else {
        scan(node);
      }
    }
  }
}).observe(document.body, { childList: true, subtree: true });
